<template>
  <v-container>
    <v-row v-if="showTable" justify="center" class="mt-10">
      <v-col col="12">
        <v-data-table :headers="headers" :items="list" class="elevation-1">
          <template v-slot:[`item.Model_InvNo`]="{ item }">
            <a v-if="item.Model_InvNo" @click.prevent="showDetail(item)">
              {{ item.Model_InvNo }}
            </a>
            <span v-else>{{ item.Model_SiteGuiType == 3 ? '無須開立' : '發票尚未開立'}}</span>
          </template>
          <template v-slot:[`item.Model_PayMethodName`]="{ item }">
            {{ item.Model_PayMethodName }}
          </template>
          <template v-slot:[`item.Model_BuyerNum`]="{ item }">
            {{ item.Model_BuyerNum }}
          </template>
          <template v-slot:[`item.Model_Amount`]="{ item }"> NT$ {{ item.Model_Amount | toThousandFilter }} </template>
          <template v-slot:[`item.Model_PayDate`]="{ item }">
            {{ item.Model_PayDate | toDateFormat('YYYY-MM-DD') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog class="dialog-view" v-model="dialog" transition="dialog-bottom-transition">
      <TradeDetailDialog :invDetailsView="invDetailsView" :download-invoice="downloadInvoice" @close="dialog = false" />
    </v-dialog>
  </v-container>
</template>

<style scoped>
.frame-line {
  border: 1px solid #999;
  border-collapse: collapse;
}

.receipt tr td {
  color: black;
  font-size: 16px;
}

table {
  border-collapse: collapse;
}

.tablecontent {
  width: 95%;
  margin: auto;
  border-collapse: collapse;
  border: 1px solid #000;
}

.headercontent {
  width: 95%;
  margin: auto;
}

.tablecontent td {
  border-right: 1px solid #000;
  vertical-align: top;
}

.tablecontent th {
  border: 1px solid #000;
}

.tablecontent td:last-child,
.tablecontent th:last-child {
  border-right: none;
}

.undertent td {
  border-bottom: 1px solid #000;
}

.fixed-height {
  height: 100px;
}
</style>

<script>
import TradeDetailDialog from '@/components/TradeInfo/TradeDetailDialog'
import { mappingToPdfText, addTextToPDF } from '@/utils/invoicePdfMapper.js';//V
import invoiceTemplate from '@/assets/invoiceTemplate.jpg';//V

export default {
  name: 'TradeInfo',
  components: {
    TradeDetailDialog
  },
  data: () => ({
    showTable: false,
    dialog: false,
    list: [],
    pdfReady: null,
    invDetailsView: {
      // PayInfo
      payDate: '',
      rentDate: '',
      siteName: '',
      rentInfoName: '',
      invoiceType: '',

      // 日期範圍
      Model_StartDate: '',
      Model_EndDate: '',

      // 載具類型與條碼
      InvInfo_CarrierType: '', // 預期是 1/2 但預設用空字串
      InvInfo_VehicleCode: '',

      // 列印狀態
      invInfo_PrintState: '',

      // Invoice 區
      invoiceNum: '',
      InvInfo_NotTaxPrice: 0,
      InvInfo_Price: 0,
      InvInfo_TaxPrice: 0,
      InvInfo_TaxType: '',

      invInfoGuiNo: '',
      invInfoMon: '',
      invInfo_Date: '',
      invInfoSellerNum: ''
    },
    downloadUseInvoiceDetails: {
      invoiceNum: 'AB12345678',
      invInfo_Date: '2025/07/03',
      invInfo_BuyerName: '小明股份有限公司',
      invInfo_BuyerNum: '',
      buyerAddress: '台北市中正區仁愛路一段1號',
      gui: '1234',
      receiptList: [
        {
          description: '項目A',
          quantity: 2,
          unit: '個',
          unitNonTax: 1000,
          amount: 2000,
        },
        {
          description: '項目B',
          quantity: 1,
          unit: '包',
          unitNonTax: 500,
          amount: 500,
        },
      ],

      comName: '好公司有限公司',
      companyRegisterNo: '台北市大安區信義路二段2號',
      siteAddress: '87654321',

      totalNonTaxAmount: 2500,
      totalTax: 125,
      totalPrice: 2625
    },
    headers: [
      { text: '發票號碼', value: 'Model_InvNo' },
      { text: '付款方式', value: 'Model_PayMethodName' },
      { text: '場地', value: 'Model_SiteName' },
      { text: '收費項目', value: 'Model_ChargeItemsName' },
      { text: '買方統編', value: 'Model_BuyerNum' },
      { text: '金額', value: 'Model_Amount' },
      { text: '交易日期', value: 'Model_PayDate' }
    ],
    invInfo: {},
    showItem: {},
    envType: process.env.VUE_APP_MODE,
    screenWidth: 0
  }),
  created() {
    this.screenWidth = screen.width;
    this.search();
  },
  computed: {
    canDownload () {
      return !!this.downloadUseInvoiceDetails?.invInfo_BuyerNum
    },
    downloadInvoice () {
      return this.canDownload
      ? async () => {
          const jsPDF = await this.ensurePdfLib();
          // eslint-disable-next-line new-cap
          const pdfDoc = new jsPDF({
            unit: 'mm',
            format: 'a4'
          });
          const data = this.downloadUseInvoiceDetails
          try {
            const img = await this.loadImage(invoiceTemplate);

          // 先轉成 Base64 Data URL
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            const dataUrl = canvas.toDataURL('image/jpeg', 1.0);

            // 將 Base64 加入 jsPDF, 資源非 Base64 好像會有轉換問題
            pdfDoc.addImage(dataUrl, 'JPEG', 0, 0, 210, 297);
            pdfDoc.setFont('eduSong_Unicode', 'normal');

          // ────── 轉換資料 ──────
            const convertData = {
              invInfo_Date: data.invInfo_Date ?? ' ',
              invoiceNum: data.invoiceNum ?? ' ',
              invInfo_BuyerName: data.invInfo_BuyerName ?? ' ',
              invInfo_BuyerNum: data.invInfo_BuyerNum ?? ' ',
              invInfo_State: data.invInfo_State ?? ' ',
              buyerAddress: data.PayInfo_buyerAddress ?? ' ',
              gui: data.invInfo_GuiNo ?? ' ',
              memo: data.payInfo_Memo ?? ' ',

            // ───── List ─────
              receiptList: data.receiptList,

            // ───── Seller 區塊 ─────
              comName: data.comName ?? ' ',
              companyRegisterNo: data.companyRegisterNo ?? ' ',
              siteAddress: data.siteAddress ?? ' ',

            // ───── Totals ─────
              totalNonTaxAmount: data.totalNonTaxAmount,
              totalTax: data.totalTax,
              totalPrice: data.totalPrice
            };
            const pdfText = mappingToPdfText(convertData);
            addTextToPDF(pdfDoc, pdfText);
            // ────── 開新分頁&下載 PDF ──────
            const url = pdfDoc.output('bloburl');
            window.open(url);
            pdfDoc.save(`${data.invoiceNum}_電子發票證明`);
            this.changeInvoicePrintState(data.invoiceNum,data.printState)
          } catch (err) {
            console.error('⚠️ PDF 產生過程錯誤（onload 執行時）:', err);
          }
        }
      : null
    }
  },
  methods: {
    search() {
      this.dbio('/TradeInfo', { Model_QueryType: 1}).then((response) => {
          this.list = response;

          if (this.list.length == 0) {
            this.msg('查無交易資訊', 2000);
          } else {
            this.showTable = true;
          }
        });
    },
    async showDetail(selectedRow) {

      const res = await this.dbio('/TradeInfo', {
        Model_QueryType: 2,
        Model_PayInfoNo: selectedRow.Model_PayInfoNo,
        Model_GroupNo: selectedRow.Model_GroupMo,
        Model_Invoice: selectedRow.Model_InvNo,
        Model_InvMon: selectedRow.Model_InvMon
      });
      // console.log('res',res);
      if (!res || Object.keys(res).length === 0) {
        this.msg('查無交易詳細資訊', 2000);
      } else {
        this.invDetailsView = {
          // from selectedRow
          payDate: (selectedRow.Model_PayDate ?? '').split('T')[0],
          siteName: selectedRow.Model_SiteName ?? '',
          rentInfoName: selectedRow.Model_RentInfoName ?? '',
          startDateToEndDate: `${(selectedRow.Model_StartDate ?? '').slice(0, 7)} ~ ${(selectedRow.Model_EndDate ?? '').slice(0, 7)}`,

          // from API
          invType: res.InvInfo_Type ?? '',
          carrierType: res.InvInfo_CarrierType ?? '',
          vehicleCode: res.InvInfo_VehicleCode ?? '',
          printState: res.InvInfo_PrintState ?? '',

          invoiceNum: res.InvInfo_Invoice ?? '',
          mon: res.InvInfo_Mon ?? '',
          guiNo: res.InvInfo_GuiNo ?? '',
          price: res.InvInfo_Price ?? 0,
          notTaxPrice: res.InvInfo_NotTaxPrice ?? 0,
          taxPrice: res.InvInfo_TaxPrice ?? 0,
          taxType: res.InvInfo_TaxType ?? '',
          state :  res.InvInfo_State ?? '',
          invInfo_Date: res.InvInfo_Date ?? '',
          sellerNum: res.InvInfo_SellerNum ?? '',
          buyerNum: res.PayInfo_BuyerNum ?? '',
          itemHeaders: [
            { text: "品項", value: "Receipt_ItemName" },
            { text: "數量", value: "Receipt_Quantity" },
            { text: "單價", value: "Receipt_UnitPrice" },
            { text: "金額", value: "Receipt_Price" }
          ],
          items: res.ReceiptList
        };
        // console.log(this.invDetailsView)
        if(res.PayInfo_BuyerNum > 0)
        {
          const processedReceipts = res.ReceiptList.map(r => {
          const quantity = r.Receipt_Quantity || 0;
          const unitNonTax = r.Receipt_NonTax|| 0;
            return {
              item: r.Receipt_ItemName || '',
              quantity,
              unitNonTax,
              amount: unitNonTax * quantity // 此為未稅金額
            };
          });
          const totalNonTaxAmount = processedReceipts.reduce((sum, r) => sum + r.amount, 0);
          const totalPrice = res.ReceiptList.reduce((sum, r) => sum + (r.Receipt_Price || 0), 0);
          const totalTax = (totalPrice - totalNonTaxAmount);

          this.downloadUseInvoiceDetails = {
            invoiceNum: res.InvInfo_Invoice ?? '',
            invInfo_Date: res.InvInfo_Date ?? '',
            invInfo_BuyerName: res.PayInfo_BuyerName ?? '',
            invInfo_BuyerNum: res.PayInfo_BuyerNum ?? '',
            payInfo_Memo: res.PayInfo_Memo?? '',
            // buyerAddress: res.Model_BuyerAddress ?? '',
            invInfo_GuiNo: res.InvInfo_GuiNo ?? '',
            receiptList: processedReceipts,
            comName: res.Company_Name ?? '',
            companyRegisterNo: res.InvInfo_SellerNum ?? '',
            siteAddress: res.Company_Full_Address ?? '',
            totalNonTaxAmount: totalNonTaxAmount ?? 0,
            totalTax: totalTax ?? 0,
            totalPrice: totalPrice ?? 0,
            // recordState
            printState: res.InvInfo_PrintState ?? '',
          };
        }
        this.dialog = true;
      }
    },
    async ensurePdfLib() {
      if (this.pdfReady) return this.pdfReady;

      // 一次載入 jsPDF 及字型檔
      this.pdfReady = Promise.all([
        import(/* webpackChunkName:"pdf-bundle" */ 'jspdf'),
        import(/* webpackChunkName:"pdf-bundle" */ '@/assets/fonts/eduSong_Unicode-normal.js')
      ]).then(([mod]) => mod.jsPDF || mod.default);

      return this.pdfReady;
    },
    loadImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
      });
    },
    async changeInvoicePrintState(invoice,currentPrintState)
    {
      switch(currentPrintState)
      {
        case 0:
          await this.dbio('/TradeInfo', {
            Model_QueryType: 3,
            Model_Invoice: invoice,
          });
          break
        case 1:
          console.log("已經列印過")
          break
        case 2:
          console.log("已經列印過")
          break
        default:
          console.log("已經列印過")
          break
      }
      return null
    }
  }
};
</script>

<style>
@media (max-width: 400px) {
  .vue-barcode-element {
    width: 228px;
    height: 60px;
  }
}
</style>
